import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { ClienteService } from "app/clientes/services/cliente.service";
import { map, Observable } from "rxjs";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { ClienteModel } from "app/clientes/models/cliente.model";

export interface DialogData {
    id: number;
}

@Component({
    selector: "app-filtrar-inconsistencias-ordens",
    templateUrl: "./filtrar-inconsistencias-ordens.component.html",
    styleUrls: ["./filtrar-inconsistencias-ordens.component.scss"]
})
export class FiltrarInconsistenciasOrdensComponent extends BaseComponent {

    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    cliente = new FormControl("");
    ativo = new FormControl("");
    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);
    assessor_id = new FormControl("");
    arquivo_id = new FormControl("");

    paramsStatus: any = {
        finalizada: ""
    };
    loadingSpinner!: boolean;
    loadingSpinnerStatus!: boolean;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerAtivos!: boolean;
    loadingSpinnerArquivos!: boolean;
    filteredOptions!: Observable<ClienteModel[]>;
    listStatus: any[] = [];
    listAssessor: any[] = [];
    listAtivos: any[] = [];
    listArquivos: any[] = [];
    filteredOptionsAtivo!: Observable<any[]>;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltrarInconsistenciasOrdensComponent>,
        private _clienteService: ClienteService,
        private _utilitesService: UtilitesService,
        private _ativoService: AtivoService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        super(dialog, snackBar);

        this.cliente.valueChanges.subscribe(
            query => {
                if (typeof query === "string" || typeof query === "number") {
                    this.loadingSpinner = true;
                    this.params.search = query;
                    this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
                }
            }
        );

        this.ativo.valueChanges.subscribe(
            query => {
                if (typeof query === "string") {
                    this.loadingSpinnerAtivos = true;
                    this.params.search = query;
                    this.params.tipo = "NORMAL";
                    this.filteredOptionsAtivo = this._ativoService.search(this.params);
                }
            }
        );

    }

    displayFn(cliente: any): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar(): void {


        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(this.data_operacao_inicio.value ?? new Date());
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(this.data_operacao_fim.value ?? new Date());
        }

        this.dialogRef.close({
            "cliente": this.cliente.value,
            "data_operacao_inicio": inic,
            "data_operacao_fim": fim,
            "ativo": this.ativo.value,
        });
    }

    displayFnAtivo(ativo: any): string {
        if (ativo) {
            return ativo.sigla;
        }
        return "";
    }


    getAtivo(ativo: any): void {
        this.loadingSpinnerAtivos = false;
    }


    getAtivos(): void {
        this.loadingSpinnerAtivos = true;
        this._ativoService.getAll({ no_paginate: true })
            .subscribe(
                resquest => {
                    this.listAtivos = resquest.data;
                },
                error => {
                    this.loadingSpinnerAtivos = false;
                },
                () => {
                    this.loadingSpinnerAtivos = false;
                    console.log("complete");
                }
            );
    }

}